var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tag',{style:(`${_setup.generateBGColor(_setup.props.tag)}; color: white;`),attrs:{"tabstop":false,"ellipsis":"","rounded":"","closable":_setup.props.closable},on:{"close":function($event){return _setup.emit('close', $event)}}},[_vm._v(" "+_vm._s(_setup.props.tag.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }